export enum ItemType {
  none = 'none',
  flower = 'flower',
  card = 'card',
  condolenceVideo = 'condolenceVideo',
  moneyGift = 'moneyGift',
}
